import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './ResponsibleImage.module.scss';

import AlternativeImage from '@shared/ui/common/AlternativeImage';

type Props = {
  image?: string;
  className?: string;
  imageClassName?: string;
  name: string;
  sizes: Array<{
    query?: number;
    maxQuery?: number;
    w: number;
    h: number;
  }>;
};

const cls = cssModules(STYLES);

const getSrcSets = (image: string, w: number, h: number) =>
  [
    `${image.replace('_WxH', `_${w}x${h}`)} 1x`,
    `${image.replace('_WxH', `_${w * 2}x${h * 2}`)} 2x`,
    `${image.replace('_WxH', `_${w * 4}x${h * 4}`)} 4x`,
  ].join(', ');

const ResponsibleImage = ({
  className,
  image,
  imageClassName,
  name,
  sizes,
}: Props) => (
  <div className={cls('ResponsibleImage', className)}>
    {image ? (
      <picture>
        {sizes.map(({ h, maxQuery, w }, index) => {
          if (index === 0) {
            return (
              <source
                key={`${w}-${h}`}
                media={`(max-width: ${maxQuery! - 1}px)`}
                srcSet={getSrcSets(image, w, h)}
              />
            );
          }
          if (index === sizes.length - 1) {
            return (
              <source
                key={`${w}-${h}`}
                media={`(min-width: ${sizes[index - 1].maxQuery}px)`}
                srcSet={getSrcSets(image, w, h)}
              />
            );
          }
          return (
            <source
              key={`${w}-${h}`}
              media={`(min-width: ${
                sizes[index - 1].maxQuery
              }px) and (max-width: ${maxQuery! - 1}px)`}
              srcSet={getSrcSets(image, w, h)}
            />
          );
        })}
        <img
          className={cls('ResponsibleImage__img', imageClassName)}
          src={image}
          alt={name}
        />
      </picture>
    ) : (
      <AlternativeImage
        className={cls('ResponsibleImage__img', imageClassName)}
        alt={name}
      />
    )}
  </div>
);

export default ResponsibleImage;
